
import "vue3-carousel/dist/carousel.css";
export default {
  name: "NotFound",
  components: {},
  setup() {
    const currentYear = new Date().getFullYear();

    return {
      currentYear,
    };
  },
};
